import { DurationCell } from './duration/DurationCell';
import { SatisfactionCell } from './SatisfactionCell';
import { TagsCell } from './tags/TagsCell';
import { OwnerCell } from './owner/OwnerCell';
import { LinksCell } from './links/LinksCell';
import { PersonasCell } from './personas/PersonasCell';
import { FormattedMessage } from 'react-intl';
import { DescriptionCell } from './description/DescriptionCell';
import { MetricsCell } from './metrics/MetricsCell';
import { PicturesCell } from './pictures/PicturesCell';
import { WidgetType } from '../../../../gql/graphql';
import { WidgetCell } from './WidgetCell';
import { OpportunitiesCell } from './opportunities/OpportunitiesCell';
import { NotesCell } from './notes/NotesCell';
import { GoalsAndObjectivesCell } from './goalsAndObjectives/GoalsAndObjectivesCell';
import { SubactivitiesCell } from './subactivities/SubactivitiesCell';
import { ActionsCell } from './actions/ActionsCell';
import { ConnectedJourneysCell } from './connectedJourneys/ConnectedJourneysCell';

export const widgetDefinitions = {
	duration: {
		name: <FormattedMessage id={'journey.detail.widget.duration.title'} />,
		type: 'duration',
		component: DurationCell,
	},
	satisfaction: {
		name: <FormattedMessage id={'journey.detail.widget.satisfaction.title'} />,
		type: 'satisfaction',
		component: SatisfactionCell,
	},
	tags: {
		name: <FormattedMessage id={'journey.detail.widget.tags.title'} />,
		type: 'tags',
		component: TagsCell,
	},
	owner: {
		name: <FormattedMessage id={'journey.detail.widget.owner.title'} />,
		type: 'owner',
		component: OwnerCell,
	},
	links: {
		name: <FormattedMessage id={'journey.detail.widget.links.title'} />,
		type: 'links',
		component: LinksCell,
	},
	personas: {
		name: <FormattedMessage id={'journey.detail.widget.personas.title'} />,
		type: 'personas',
		component: PersonasCell,
	},
	description: {
		name: <FormattedMessage id={'journey.detail.widget.description.title'} />,
		type: 'description',
		component: DescriptionCell,
	},
	metrics: {
		name: <FormattedMessage id={'journey.detail.widget.metrics.title'} />,
		type: 'metrics',
		component: MetricsCell,
	},
	pictures: {
		name: <FormattedMessage id={'journey.detail.widget.pictures.title'} />,
		type: 'pictures',
		component: PicturesCell,
	},
	opportunities: {
		name: <FormattedMessage id={'journey.detail.widget.opportunities.title'} />,
		type: 'opportunities',
		component: OpportunitiesCell,
	},
	actions: {
		name: <FormattedMessage id={'journey.detail.widget.actions.title'} />,
		type: 'actions',
		component: ActionsCell,
	},
	subactivities: {
		name: <FormattedMessage id={'journey.detail.widget.subactivities.title'} />,
		type: 'subactivities',
		component: SubactivitiesCell,
	},
	goalsandobjectives: {
		name: <FormattedMessage id={'journey.detail.widget.goalsandobjectives.title'} />,
		type: 'goalsandobjectives',
		component: GoalsAndObjectivesCell,
	},
	notes: {
		name: <FormattedMessage id={'journey.detail.widget.notes.title'} />,
		type: 'notes',
		component: NotesCell,
	},
	connectedjourneys: {
		name: <FormattedMessage id={'journey.detail.widget.connected-journeys.title'} />,
		type: 'connectedjourneys',
		component: ConnectedJourneysCell,
	},
	empty: {
		name: <></>,
		type: 'empty',
		component: () => <WidgetCell />,
	},
} as const;

type WidgetDefinitions = typeof widgetDefinitions;

type WidgetDefinition = WidgetDefinitions[keyof WidgetDefinitions];

const isValidDefinition = (type: string): type is keyof WidgetDefinitions => {
	return type in widgetDefinitions;
};

export const getWidget = (type: WidgetType): WidgetDefinition => {
	if (isValidDefinition(type)) {
		return widgetDefinitions[type];
	}
	return widgetDefinitions['empty'];
};
